// eslint-disable-next-line import/prefer-default-export
export const GetResourceMobilizationSelector = ({
  resourceMobilization: { GetResourceMobilization }
}) => GetResourceMobilization;

export const PostResourceMobilizationSelector = ({
  resourceMobilization: { PostResourceMobilization }
}) => PostResourceMobilization;
